const ArrowVerifyBackIcon = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0005 13.1667C9.8725 13.1667 9.74448 13.1181 9.64715 13.0201L4.98048 8.35341C4.78515 8.15808 4.78515 7.84139 4.98048 7.64605L9.64715 2.97939C9.84248 2.78405 10.1592 2.78405 10.3545 2.97939C10.5498 3.17472 10.5498 3.49141 10.3545 3.68674L6.04119 8.00006L10.3545 12.3134C10.5498 12.5087 10.5498 12.8254 10.3545 13.0207C10.2565 13.1181 10.1285 13.1667 10.0005 13.1667Z"
      fill="#FCFCFD"
    />
  </svg>
);
export default ArrowVerifyBackIcon;
